import Form from './form'
import ExtensionService from 'live/services/extension'

const plugin = {
    name: 'ETL',
    type: 'etl',
    origin: 'Plugin ETL',
    icon: '/content/plugin-etl/etl.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(plugin)
